import script from "./_id.vue?vue&type=script&setup=true&lang=ts"
export * from "./_id.vue?vue&type=script&setup=true&lang=ts"

import "./_id.vue?vue&type=style&index=0&id=aff48ebc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aff48ebc"]])

export default __exports__